var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChatbotSendIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "send-2 (1)",
  width: "1em",
  height: "1em",
  viewBox: "0 0 28.021 28.021"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2924",
  d: "M0 0h28.021v28.021H0z",
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2925",
  d: "M5.485 4.71l19.033 9.3-19.033 9.3a.587.587 0 01-.637-.145.648.648 0 01-.14-.663l2.881-8.492-2.882-8.492a.648.648 0 01.14-.663.587.587 0 01.637-.145z",
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2926",
  d: "M7.589 14.01h16.929",
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default __webpack_public_path__ + "static/ChatbotSendIcon.ef4911fc20970fae72897ecbd365cf9d.svg";
export { SvgChatbotSendIcon as ReactComponent };